import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MainLayout from './MainLayout';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const role = localStorage.getItem('role');
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  useEffect(() => {
    if (role !== 'Admin') {
      navigate('/dashboard'); // 🚫 Block access if not Admin
      return;
    }

    const fetchUsers = async () => {
      try {
        const response = await axios.get('https://openmkm.vidyayug.com/api/admin/users', {
          headers: {
            Authorization: `${token}`,
          },
        });
        setUsers(response.data.users);
      } catch (err) {
        console.error(err);
        setError('Failed to fetch users.');
      }
    };

    fetchUsers();
  }, [role, token, navigate]);

    const handleRoleChange = (userId, newRole) => {
    setUsers((prev) =>
        prev.map((user) =>
        user.id === userId ? { ...user, role: newRole } : user
            )
        );
    };

    const updateRole = async (userId, newRole) => {
    try {
        await axios.put(
        `https://openmkm.vidyayug.com/api/admin/users/${userId}/role`,
        { role: newRole },
        {
            headers: {
            Authorization: `${token}`,
            },
        }
        );
        toast.success('Role updated successfully!');
    } catch (err) {
        console.error('Failed to update role', err);
        toast.error('Failed to update role.');
    }
    };


  return (
    <MainLayout>
      <div style={styles.container}>
        <h2>User Management</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>First Name</th>
              <th style={styles.th}>Last Name</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Role</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
                <tr key={user.id}>
                <td style={styles.td}>{user.id}</td>
                <td style={styles.td}>{user.first_name}</td>
                <td style={styles.td}>{user.last_name}</td>
                <td style={styles.td}>{user.email}</td>
                <td style={styles.td}>
                    <select
                    value={user.role}
                    onChange={(e) => handleRoleChange(user.id, e.target.value)}
                    style={styles.select}
                    >
                    <option value="Admin">Admin</option>
                    <option value="BusinessUser">BusinessUser</option>
                    <option value="AssociateResearcher">AssociateResearcher</option>
                    </select>
                </td>
                <td style={styles.td}>
                    <button
                    onClick={() => updateRole(user.id, user.role)}
                    style={styles.updateButton}
                    >
                    Update
                    </button>
                </td>
                </tr>
            ))}
            </tbody>
        </table>
      </div>
    </MainLayout>
  );
};

const styles = {
  container: {
    padding: '20px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
  },
  th: {
    textAlign: 'left',
    borderBottom: '2px solid #ccc',
    padding: '8px',
  },
  td: {
    padding: '8px',
    borderBottom: '1px solid #eee',
  },
  select: {
    padding: '6px 10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '14px',
  },
  updateButton: {
    padding: '6px 12px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#007bff',
    color: '#fff',
    fontSize: '14px',
    cursor: 'pointer',
  },
};

export default UserManagement;
